import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { SidebarProvider, useSidebar } from '@features/ui';
import { cn } from '@lib/utils';
import { isBoolean } from 'lodash';
import { RightSidebar } from '@features/core/ui/layout/rightSidebar.tsx';
import { AuthUser } from '@src/types';
import { FC } from 'react';

import { UserSidebar } from './userSidebar';
import { UserHeader } from './userHeader';

const UserSidebarContent = () => {
  const { isRight } = useSidebar();
  const location = useLocation();

  const hiddenLayout = location.pathname.includes('/create-pa-account');

  if (hiddenLayout) {
    return (
      <div className={'flex-1 mt-8.5 sm:mx-5 mx-2'}>
        <div className={'overflow-auto w-full'}>
          <Outlet />
        </div>
      </div>
    );
  }

  return (
    <>
      {isRight ? <RightSidebar isUser /> : <UserSidebar />}
      <div
        className={cn(
          'ml-auto w-full max-w-full',
          'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
          'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
          'transition-[width] duration-200 ease-linear',
          'flex h-svh flex-col',
          'group-data-[scroll-locked=1]/body:h-full',
          'group-data-[scroll-locked=1]/body:has-[main.fixed-main]:h-svh',
          'p-3 md:p-0'
        )}
        id="content"
      >
        <UserHeader />
        <div className={'flex-1 mt-8.5 sm:mx-5 mx-2'}>
          <div className={'overflow-auto w-full'}>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

interface UserLayoutProps {
  me?: AuthUser | null;
  loading?: boolean;
}

export const UserLayout: FC<UserLayoutProps> = ({ me }) => {
  if (isBoolean(me?.complete_onboarding) && !me?.complete_onboarding) {
    return <Navigate replace={true} to={'/review-checkout'} />;
  }

  return (
    <div>
      <SidebarProvider>
        <UserSidebarContent />
      </SidebarProvider>
    </div>
  );
};
